import { render, staticRenderFns } from "./NameDetailProductVertical.vue?vue&type=template&id=2d59b537&"
import script from "./NameDetailProductVertical.vue?vue&type=script&lang=js&"
export * from "./NameDetailProductVertical.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports